// extracted by mini-css-extract-plugin
export default {"bg-gray":"EditWarehouseDetail_bg-gray__g7ugh"};